import AccountLayout from '../components/AccountLayout';
import AppointmentDetailPage from './AppointmentDetailPage';
import { useTranslation } from 'react-i18next';

/**
 * Wraps AppointmentDetailPage inside AccountLayout so the sidebar
 * and account navigation context are preserved.
 */
export default function AccountAppointmentDetailPage() {
  const { t } = useTranslation();
  return (
    <AccountLayout>
      <AppointmentDetailPage />
    </AccountLayout>
  );
}
